var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createPerimeter } from 'vue-kindergarten';
import checks from './Checks';
export default createPerimeter(__assign({}, checks, { purpose: 'role', can: {
        admin: function () {
            return this.isAdmin();
        },
        driver: function () {
            return this.isDriver();
        },
        root: function () {
            return this.isAdmin() || this.isDriver();
        }
    } }));



//////////////////
// WEBPACK FOOTER
// ./services/kindergarten/perimeters/Role.ts
// module id = ./services/kindergarten/perimeters/Role.ts
// module chunks = 0 1 3 10 11 15 18